import { render, staticRenderFns } from "./PopupConfirm.vue?vue&type=template&id=3dd908e2"
import script from "./PopupConfirm.vue?vue&type=script&lang=js"
export * from "./PopupConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports